<template>

  <t-page>

    <t-page-list :title="'Listagem de ' + pageTitle.title" :buttonInsert="{text:'Incluir Exemplo',to:'sales-quotes-form'}" :user-auth="userAuth"
                 :total-pages="request.totalPages" :breadcrumb="breadcrumb" @getPage="getPage">

      <template #search>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form" />
      </template>

      <b-table hover :items="request.content" :fields="fields">

        <template #cell(first)="{item}">
          <t-list-link-primary :label="item.name" :userAuth="userAuth"/>
        </template>

        <template #cell(status)="{item}">
          {{ item.status | statusLabel }}
        </template>

        <template #cell(actions)>
          <t-list-actions-default :userAuth="userAuth"/>
        </template>

      </b-table>

    </t-page-list>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin";



export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'ProductsClasses',
  data() {
    return {
      fields: [
        {
          key: "first",
          label: "Full Name"
        },
        {
          key: "status",
          label: "User Address"
        },
        {
          key: "actions",
          label: ""
        },
      ],
    }
  },
  methods: {},
  mounted() {




    /*
    * Mokado testes
    * ------------------------------------------------------------------ */

    this.request = {
      "content": [
        {
          "classId": 1,
          "name": "Teste 1",
          "status": 1
        },
        {
          "classId": 2,
          "name": "Nova class 3",
          "status": 1
        },
        {
          "classId": 3,
          "name": "Nova class 3",
          "status": 1
        }
      ]
    }
    /*
    * ------------------------------------------------------------------ */

  },
  computed: {},

}
</script>
